const ASSIGNABLE_ORG_ROLES = new Set([
  "admin",
  "coach",
  "member",
  "investor",
]);

export async function updateAuthoritativeOrgUserRole({
  currentUser,
  functionsBaseUrl,
  orgId,
  targetUserId,
  role,
  fetchImpl = null,
} = {}) {
  const safeBaseUrl = String(functionsBaseUrl || "").trim().replace(/\/+$/, "");
  const safeOrgId = String(orgId || "").trim();
  const safeTargetUserId = String(targetUserId || "").trim();
  const safeRole = String(role || "").trim().toLowerCase();
  if (!currentUser || typeof currentUser.getIdToken !== "function") {
    throw new Error("A fresh authenticated session is required.");
  }
  if (
    !safeBaseUrl ||
    !safeOrgId ||
    !safeTargetUserId ||
    safeOrgId.includes("/") ||
    safeTargetUserId.includes("/")
  ) {
    throw new Error("Role update service and canonical membership are required.");
  }
  if (!ASSIGNABLE_ORG_ROLES.has(safeRole)) {
    throw new Error("A canonical assignable role is required.");
  }
  const request = fetchImpl || (
    typeof fetch === "function" ? fetch : null
  );
  if (!request) {
    throw new Error("Role update service is unavailable.");
  }

  const token = await currentUser.getIdToken(true);
  const response = await request(`${safeBaseUrl}/updateOrgUserRole`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      orgId: safeOrgId,
      targetUserId: safeTargetUserId,
      role: safeRole,
    }),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok || payload?.ok !== true) {
    throw new Error(payload?.error || "Role update failed.");
  }
  const responseOrgId = String(payload.orgId || "").trim();
  const responseTargetUserId = String(payload.targetUserId || "").trim();
  const responseRole = String(payload.role || "").trim().toLowerCase();
  if (
    responseOrgId !== safeOrgId ||
    responseTargetUserId !== safeTargetUserId ||
    responseRole !== safeRole
  ) {
    throw new Error("Role update response did not match the canonical request.");
  }
  return {
    orgId: responseOrgId,
    targetUserId: responseTargetUserId,
    role: responseRole,
    refreshBoundary: String(payload.refreshBoundary || ""),
  };
}
